import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import SettingsWelcomeScreenRoute from 'garaje/pods/visitors/settings/welcome-screen/route';
import type FeatureFlagsService from 'garaje/services/feature-flags';

export default class VirtualFrontDeskSettingsRoute extends SettingsWelcomeScreenRoute {
  @service declare featureFlags: FeatureFlagsService;
  @service declare router: RouterService;

  redirect(): void {
    if (this.featureFlags.isEnabled('vfd-hours-of-operation')) {
      void this.router.replaceWith('virtual-front-desk.settings.call-operations');
    } else {
      void this.router.replaceWith('virtual-front-desk.settings.welcome-screen');
    }
  }
}
